export const buildSandboxUrl = (testingUrl: string, branch: string) => {
  const url = new URL(testingUrl);

  url.hostname = url.hostname.replace('-testing', '-sandbox');
  url.hostname = url.hostname.replace('.testing', '.sandbox');

  url.pathname = `/${branch}${url.pathname}`;

  return url.toString();
};
